"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapIcon = void 0;
var _react = require("react");
var _MapIconInner = _interopRequireDefault(require("./MapIconInner"));
var _MapIconMain = _interopRequireDefault(require("./MapIconMain"));
var _MapIconShadow = _interopRequireDefault(require("./MapIconShadow"));
var _useMapIcon = require("./useMapIcon");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * SVG element for usage on maps. Sizes are available in mapIconInfo
 * @param props MapIconProps
 * @returns JSX.IntrinsicElements.svg
 */
const MapIcon = props => {
  const {
    mapData
  } = (0, _useMapIcon.useMapIcon)(props);
  const mapIcon = (0, _react.useMemo)(() => {
    const shadowDefinition = mapData.iconType === 'currentLocation' ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_MapIconShadow.default, {
      width: mapData.width,
      height: mapData.height,
      x: mapData.shadowX,
      y: mapData.shadowY
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      width: mapData.width,
      height: mapData.height,
      viewBox: mapData.vBox,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [shadowDefinition, /*#__PURE__*/(0, _jsxRuntime.jsx)(_MapIconMain.default, {
        iconType: mapData.iconType,
        pinColor: mapData.color,
        clusterSize: mapData.clusterSize
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MapIconInner.default, {
        color: mapData.innerColor,
        iconType: mapData.iconType
      })]
    });
  }, [mapData.color, mapData.clusterSize, mapData.height, mapData.iconType, mapData.innerColor, mapData.shadowX, mapData.shadowY, mapData.vBox, mapData.width]);
  return mapIcon;
};
exports.MapIcon = MapIcon;
var _default = exports.default = MapIcon;